<template>
  <v-app>
    <SystemAlert />

    <ServiceNotAvailable v-if="showServiceNotAvailablePage" />

    <template v-else>
      <Loading />

      <RippleResult />

      <SystemDialog />

      <v-main>
        <transition :name="transitionName">
          <keep-alive>
            <router-view
              style="
                position: fixed;
                width: 100vw;
                height: 100vh;
                background: white;
              "
            ></router-view>
          </keep-alive>
        </transition>
      </v-main>

      <CheckIn />

      <BottomNavigationBar />
    </template>
  </v-app>
</template>

<script>
  import BottomNavigationBar from "@/components/BottomNavigationBar";
  import Loading from "@/components/Loading";
  import RippleResult from "@/components/RippleResult";
  import SystemDialog from "@/components/SystemDialog";
  import geolocationHelper from "@/helpers/geolocationHelper";
  import SystemAlert from "@/components/SystemAlert";
  import CheckIn from "@/components/CheckIn";
  import ServiceNotAvailable from "@/components/ServiceNotAvailable";

  import { mapState, mapMutations } from "vuex";
  import axios from "axios";
  import Vue from "vue";
  import constants from "@/helpers/constants";
  import validators from "@/helpers/validators";
  import moment from "moment";

  export default {
    name: "App",
    components: {
      BottomNavigationBar,
      Loading,
      RippleResult,
      SystemDialog,
      SystemAlert,
      CheckIn,
      ServiceNotAvailable,
    },
    data: () => ({
      showServiceNotAvailablePage: false,
      transitionName: "nextPageTransition",
      activeBtn: 0,
      allScreenHeights: 0,
      detectingBranchWithGps: false,
    }),
    methods: {
      ...mapMutations([
        "updateLocationInfoFromGps",
        "updateTime"
      ]),
      onResize() {
        //Don't really have to set it in this case
        //window.innerHeight is much more reliable than "100vh" across browsers
        // document.body.style.height = this.screenHeight + "px";
        // this.allScreenHeights = JSON.stringify(this.screenHeights(), null, 4);
        // console.debug(
        //   "App onResize - screenheight & bottomNavigationHeight - ",
        //   this.screenHeight(),
        //   this.bottomNavigationHeight(),
        //   this.allScreenHeights
        // );
      },
      startUpdatingTime() {
        this.updateTime(this.getTime());

        console.debug(
          "Time",
          this.time.nowMoment.format(),
          this.time.todayMoment.format()
        );

        //TODO: Don't forget to put it back after testing!
        setInterval(() => {
          this.updateTime(this.getTime());

          // console.debug(
          //   "Time",
          //   this.time.nowMoment.format(),
          //   this.time.todayMoment.format()
          // );
        }, window.$settings.updatingTimeInterval);
      },
      startDetectingBranchWithGps() {
        if (this.detectingBranchWithGps) {
          return;
        }

        this.detectingBranchWithGps = true;

        //Lenient logic - Only update Vuex when a branch is detected, else ignore
        const getCurrentGeolocationBrowserCallback = (locationInfo) => {
          const atBranch = this.settings.menus.branchMenus.find((x) => {
            return geolocationHelper.isInRange(
              locationInfo.longitude,
              locationInfo.latitude,
              x.geolocationInfo
            );
          });

          if (atBranch) {
            // console.debug("getCurrentGeolocationBrowserCallback", atBranch);
            this.updateLocationInfoFromGps(atBranch);
          }
        };

        geolocationHelper.getCurrentGeolocationBrowser(
          getCurrentGeolocationBrowserCallback
        );

        //TODO: Remember to enable it back
        setInterval(() => {
          geolocationHelper.getCurrentGeolocationBrowser(
            getCurrentGeolocationBrowserCallback
          );
        }, window.$settings.getGeolocationInterval);
      },
      showWarningMessageInHostileEnvironment() {
        if (this.isUnsupportedBrowser()) {
          console.log("App Detected Unsupported Browser!");
          this.updateSystemAlert({
            show: true,
            success: false,
            message: window.$msg.unsupportedBrowser,
          });
        }
        else if (!this.isMobileDevice()) {
          console.log("App Detected Not Mobile Browser!");
          //else if (!this.isMobileDevice() && (this.$route.name !== null && this.$route.name !== "SeatsAvailability")) {
          this.updateSystemAlert({
            show: true,
            success: false,
            message: window.$msg.suggestMobile,
          });
        }
      },
      showNotificationMessage() {
        console.log("App Notified!");
        this.updateSystemAlert({
          show: true,
          success: false,
          message: window.$msg.notificationMessage,
        });
      },
      setTransitionName(to, from) {
        let toDepth = to.path.length;
        let fromDepth = from.path.length;

        //Custom logic for paths in with "Common", they r kind of considered the last route
        if (to.path.toLowerCase().includes("common")) {
          toDepth += 20;
        }

        if (from.path.toLowerCase().includes("common")) {
          fromDepth += 20;
        }

        const fromPathSlashCount = from.path.split("/").length - 1;
        const toPathSlashCount = to.path.split("/").length - 1;

        if (fromPathSlashCount === 1 && toPathSlashCount === 1) {
          //Custom logic to avoid transition between first level pages in bottom navigation bar
          this.transitionName = null;
        } else {
          this.transitionName =
            toDepth < fromDepth ? "backPageTransition" : "nextPageTransition";
        }
      },
    },
    watch: {
      $route(to, from) {
        this.setTransitionName(to, from);
      },
      settings(newValue, oldValue) {
        if (newValue) {
          this.startDetectingBranchWithGps();
        }
      },
      onsiteMode: {
        immediate: true,
        handler(newValue, oldValue) {
          this.setThemeColorByMode();
        },
      },
    },
    created() {
      console.log("App created!");

      if (window.$settings.showServiceNotAvailablePage) {
        this.showServiceNotAvailablePage = true;
      } else {
        this.startUpdatingTime();
      }
    },
    mounted() {
      //New setting to hide or show unsupported browser or non-mobile browser system alert
      if (!window.$settings.disableNotifications) {
        if (window.$settings.showOnlyNotification) {
          this.showNotificationMessage();
        } else {
          this.showWarningMessageInHostileEnvironment();
        }
      }
    },
  };
</script>

<style>
  html {
    /* Don't need to do this. This is just sympton */
    overflow-x: hidden !important;
  }

  /* Vuetify is trying to kill me */
  .v-application--wrap {
    min-height: 0 !important;
  }

  /* Remove highlighted active background color or flat */
  :hover:before {
    background-color: transparent !important;
  }

  #app {
    background-color: black;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }

  .v-text-field {
    margin: 0 !important;
    padding: 0 !important;
  }

  .v-input__prepend-inner {
    padding-right: 12px !important;
  }

    .v-input__prepend-inner .v-icon {
      color: var(--v-primary-base) !important;
    }

  .theme--light.v-label {
    color: black !important;
  }

  .theme--light.v-date-picker-table th,
  .theme--light.v-date-picker-table .v-date-picker-table--date__week {
    color: black !important;
  }

  .text-xxsmall {
    font-size: 10px !important;
  }

  .text-xsmall {
    font-size: 12px !important;
  }

  .text-xsmall {
    font-size: 12px !important;
  }

  .text-xsmall-weight {
    font-size: 12px !important;
    color: rgba(0, 0, 0, 0.54) !important;
    font-weight: 500;
  }

  .text-smaller {
    font-size: 13px !important;
    color: rgba(0, 0, 0, 0.54) !important;
    font-weight: 500;
  }

  .text-small {
    font-size: 14px !important;
    color: rgba(0, 0, 0, 0.54) !important;
    font-weight: 500;
  }

  .text-medium {
    font-size: 15px !important;
    font-weight: bold !important;
  }

  .text-large {
    font-size: 28px !important;
    font-weight: bold !important;
  }

  .icon-smaller {
    font-size: 15px !important;
    color: var(--v-primary-base) !important;
  }

  .icon-small {
    font-size: 16px !important;
    color: var(--v-primary-base) !important;
  }

  .text-title,
  .text-title-black {
    font-size: 18px !important;
    font-weight: bold !important;
  }

  .text-title-black {
    color: black;
  }

  .text-title-medium {
    font-size: 15px !important;
    font-weight: bold !important;
    color: black;
  }

  .flex-center-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .flex-center-container2 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 10px;
  }

  .flex-center-left-container {
    display: flex;
    align-items: center;
  }

  .fixed-center {
    position: fixed;
    height: 100vh;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .fixed-center2 {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  /* Added to ensure QR camera frame displays correctly across different browsers */
  .fixed-center3 {
    height: 100vh;
    width: 100vw;
    object-fit: cover;
  }

  nlb-notice.bs4-mb-3 {
    margin-bottom: 0 !important; /* Set margin-bottom to 0 to override the padding that comes with nlb-notice component */
  }

  .fixed-bottom {
    height: 100vh;
    position: fixed;
    left: 50%;
    bottom: 3%;
    transform: translate(-50%, -50%);
  }

  .fixed-bottom2 {
    position: fixed;
    left: 50%;
    bottom: 3%;
    transform: translate(-50%, -50%);
  }

  .v-tabs-slider-wrapper {
    height: 5px !important;
  }

  .box-shadow {
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  }

  /* Standardize toolbar title */
  .v-toolbar__title {
    font-weight: bold;
  }

  /* Page transition starts */
  .nextPageTransition-enter-active {
    animation: slideUpIn 100ms ease-out;
  }

  .nextPageTransition-leave-active {
    animation: slideUpOut 200ms;
  }

  .text-shadow {
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
  }

  .inset-box-shadow {
    box-shadow: 0px 1px 3px -1px rgba(0, 0, 0, 0.2) inset !important;
  }

  .box-shadow-inset {
    box-shadow: 0px 1px 3px -1px rgba(0, 0, 0, 0.2) inset !important;
  }

  /* .text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  } */

  .bg-blue-dark {
    background-image: radial-gradient(circle, #0047BB, #0047BB) !important;
  }

  .bg-teal-radial {
    background-image: radial-gradient(circle, #009688, #004d40) !important;
  }

  .bg-blue-radial {
    background-image: radial-gradient(circle, #2196f3, #0d47a1) !important;
  }

  .bg-orange-radial {
    background-image: radial-gradient(circle, #ff9800, #e65100) !important;
  }

  .bg-red-radial {
    background-image: radial-gradient(circle, #f44336, #b71c1c) !important;
  }

  .bg-black-radial {
    background-image: radial-gradient(circle, #424242, #000000) !important;
  }

  @keyframes slideUpIn {
    from {
      transform: translateY(100px);
    }

    to {
      transform: translateY(0px);
    }
  }

  @keyframes slideUpOut {
    from {
      transform: translateY(0px);
    }

    to {
      transform: translateY(-10px);
    }
  }

  .backPageTransition-enter-active {
    animation: slideUpOut 200ms ease-out reverse;
  }

  .backPageTransition-leave-active {
    animation: slideDownOut 100ms ease-in;
    z-index: 1;
  }

  @keyframes slideDownOut {
    0% {
      transform: translateY(0px);
    }

    100% {
      transform: translateY(20vh);
      opacity: 0;
    }
  }
  /* Page transition ends */

  .scrollable {
    overflow-y: auto;
  }

  .v-slide-group__prev,
  .v-slide-group__prev--disabled {
    position: absolute;
  }
</style>
